import React from 'react';
import styled from 'styled-components';

import RevenueMainOptionsBar from '../../containers/revenue/RevenueMainOptionsBar';
import { charts, views } from '../../constants/event';
import RevenueLabelsPane from '../../containers/labels/RevenueLabelsPane';
import EventChart from '../../chart/EventChart';
import RevenueTablePane from '../../containers/revenue/RevenueTablePane';
import RevenueExecutionOptionsBar from '../../containers/revenue/RevenueExecutionOptionsBar';

const MainPainContainer = styled.div`
  overflow: auto;
  flex-grow: 1;
  height: 100%;

  .main-pain__sub-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 20px 0;
  }

  .options-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .result-container {
    margin-top: 20px;
  }

  .chart-container {
    height: 400px;
  }
`;

const RevenueMainPane = (props) => {
  const { options } = props;

  return (
    <MainPainContainer>
      <div className="main-pain__sub-container">
        <div className="options-bar">
          <RevenueMainOptionsBar />
          <RevenueExecutionOptionsBar />
        </div>
        <div className="result-container">
          {charts.includes(options.view) && (
            <>
              <div className="chart-container">
                <EventChart {...props} showSort />
              </div>
              <div className="st-labels-chart">
                <RevenueLabelsPane />
              </div>
            </>
          )}
          {options.view === views.TABLE && <RevenueTablePane />}
        </div>
      </div>
    </MainPainContainer>
  );
};

export default RevenueMainPane;
